export const patterns = {
    age: '[0-9]*',
    date: '[0-9]*',
    tel: '[0-9]*',
    usTel: '[0-9]*',
    postcode: '[0-9]*',
    zipcode: '[0-9]*',
    digits: '[0-9]*',
};
export const inputModes = {
    email: 'email',
    age: 'tel',
    date: 'tel',
    tel: 'tel',
    usTel: 'tel',
    zipcode: 'tel',
    postcode: 'tel',
    digits: 'tel',
};
export const autocomplete = {
    email: 'username',
    username: 'username',
    password: 'current-password',
};
export const types = {
    password: 'password',
};
//# sourceMappingURL=constants.js.map